module.exports = __webpack_public_path__ + "img/manat-sign.3f4ef664.svg";